// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_V9St8){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3dIlc .dualColumn_Z-_lI{display:flex;align-content:space-between}.nsAddressForm_3dIlc .dualColumn_Z-_lI .firstCol_1cJs9{margin-right:20px}.optional_Mz9Qp{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_V9St8",
	"nsAddressForm": "nsAddressForm_3dIlc",
	"dualColumn": "dualColumn_Z-_lI",
	"firstCol": "firstCol_1cJs9",
	"optional": "optional_Mz9Qp"
};
module.exports = exports;
